import { Injectable } from '@angular/core';
import { HostedPaymentsSelectPaymentMethodPaymentAccountsActions } from '../component-actions/hosted-payments-page';
import { BaseEffect } from '../helpers';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  LoadingSpinnerService,
  PaymentAccountsHelperService,
} from '@arc/unified-payments-frontend/shared-payment';
import { UserNotificationAction } from '@arc/arc-shared-frontend';
import { exhaustMap, of } from 'rxjs';
import {
  PoaSelectPaymentMethodPaymentAccountActions,
  PoiSelectPaymentMethodPaymentAccountActions,
} from '../component-actions';

@Injectable()
export class PaymentAccountsEffects extends BaseEffect {
  constructor(
    private paymentAccountsHelperService: PaymentAccountsHelperService,
    actions$: Actions,
    loadingSpinnerService: LoadingSpinnerService,
  ) {
    super(actions$, loadingSpinnerService);
  }

  createPaymentAccountError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        HostedPaymentsSelectPaymentMethodPaymentAccountsActions.createPaymentAccountError,
        PoiSelectPaymentMethodPaymentAccountActions.createPaymentAccountError,
        PoaSelectPaymentMethodPaymentAccountActions.createPaymentAccountError,
      ),
      exhaustMap((action) =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.paymentAccountsHelperService.parsePaymentAccountError(
              action.error,
            ),
          }),
        ),
      ),
    ),
  );
}
